<template>
    
    <v-layout row wrap>
            
        <v-tabs dark centered>

            <v-tabs-bar class="grey darken-3">
               <v-tabs-slider color="orange"></v-tabs-slider>
                    <v-tabs-item href="#tab1" >
                        <v-btn flat class="grey--text">
                            Stammdaten
                        </v-btn>
                    </v-tabs-item>
            </v-tabs-bar>    

            <v-tabs-items>
                <v-tabs-content id="tab1">
                    <div>
                        <keep-alive>
                            <form-one v-on:submitted="submitForm"></form-one>
                        </keep-alive>
                    </div>
                </v-tabs-content>
            </v-tabs-items>
        </v-tabs>    
              
    </v-layout>

    
</template>

<script>

import formOne from './createFirmen_1.vue';

export default {
    components: {
        'form-one': formOne,
        
    },
    data() {
        return {
            
                 
        }
    }, 
    methods: {
        submitForm: function(fa) {
            this.$store.commit('setMessagebar', false)             
            this.$store.dispatch('postFirma', fa).then((response) => {    
                this.$store.dispatch('setFirma', response.id).then(()=>{
                    this.$router.replace({name:'firmen_edit', params: {id: response.id}})                
                })
            })
            this.$store.commit('setMessagebar', true)             
        }
        
    },
    created(){
        
        
    },
    
}
</script>

<style>
   
    
</style>



// WEBPACK FOOTER //
// createFirmen.vue?c02ef8d8